export default "__VITE_ASSET__voW$5$9H__"